<template>
  <div :class="'outside-click-holder'">
    <div class="form-input-wrapper autocomplete-main-wrapper">
      <label class="form-label" :for="id">
        <span>{{ label != undefined ? label : type }}</span
        ><span v-if="required">*</span>
      </label>
      <div class="autocomplete-wrapper">
        <input
          :id="id"
          :class="['form-autocomplete', invalid?'invalid':'']"
          type="text"
          :name="name"
          :placeholder="placeholder"
          :required="required"
          @input="onChange(type)"
          v-model="search"
        />
        <div class="autocomplete-confirm" @click="displaySelectedResults">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="10"
            viewBox="0 0 21 10"
          >
            <g>
              <g>
                <path
                  fill="#3326ae"
                  d="M20.94 4.303L16.26.026a.39.39 0 0 0-.427-.06.355.355 0 0 0-.232.354v2.737H.39a.379.379 0 0 0-.28.11.381.381 0 0 0-.11.28v2.347a.38.38 0 0 0 .11.28.38.38 0 0 0 .28.11h15.212v2.738c0 .163.077.281.231.354a.38.38 0 0 0 .427-.073l4.68-4.326a.4.4 0 0 0 0-.574z"
                />
              </g>
            </g>
          </svg>
        </div>
      </div>
      <div class="results-selected-wrapper">
        <div v-if="results_final.uid != ''"
          class="result-selected"
        >
          <div class="remove-result" @click="removeSelectedResult()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 22 22"
            >
              <g>
                <g>
                  <path
                    fill="#eae9ee"
                    d="M18.774 3.2c4.301 4.3 4.301 11.274 0 15.574-4.3 4.301-11.273 4.301-15.574 0-4.3-4.3-4.3-11.273 0-15.574 4.3-4.3 11.274-4.3 15.574 0z"
                  />
                </g>
                <g>
                  <path
                    fill="#191e2c"
                    d="M12.388 14.263l-1.404-1.41-1.405 1.41a1.321 1.321 0 0 1-1.872 0 1.331 1.331 0 0 1 0-1.879l1.404-1.408-1.404-1.409a1.331 1.331 0 0 1 0-1.878 1.321 1.321 0 0 1 1.872 0l1.405 1.408 1.404-1.408a1.321 1.321 0 0 1 1.872 0c.517.518.517 1.36 0 1.878l-1.404 1.409 1.404 1.408c.517.519.517 1.36 0 1.879a1.321 1.321 0 0 1-1.872 0z"
                  />
                </g>
              </g>
            </svg>
          </div>
          <div :class="'result-name rsn'+ type">
            <span class="result-name-span">{{ results_final.name }} </span>
          </div>
        </div>
      </div>
      <div
        id="autocomplete-results"
        v-show="false"
        :class="'autocomplete-results autocomplete-results-' + type"
      >
        <div class="loading" v-if="isLoading">
          {{ loadText }}
        </div>
        <div v-else v-for="(result, i) in results" :key="i">
          <div
            :class="
              'autocomplete-checkbox-wrapper autocomplete-checkbox-' +
              type +
              ' cwrap' +
              i
            "
            @click="selectCheckboxValue(i, type)"
          >
            <label
              :for="'autocomplete-result' + i"
              :value="result.link"
              :isfiz="result.is_fiz"
              >{{ result.value }}</label
            >
            <div :id="'autocomplete-result' + i" class="custom-checkbox">
              <div class="check"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- end autocomplete results -->

      <!-- ako input nije prazan i ako ne postoji osoba za autocomplete -->
      <span v-if="search.length" v-show="isUnavailable" class="unavailableText">
        {{ noResText }}
      </span>
    </div>
  </div>
</template>

<script>
import clickAnim from "@/plugins/anim_functions";
import $ from "jquery";
import gsap from "gsap";

export default {
  props: {
    label: String,
    name: String,
    type: String,
    id: String,
    required: String,
    vmodel: String,
    placeholder: String,
    start:String,
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    isAsync: {
      type: Boolean,
      required: false,
      default: false,
    },
    invalid:false,
  },
  data() {
    return {
      isOpen: false,
      results: [],
      results_selected: {"uid":'', "name":''},
      results_final: {"uid":'', "name":''},
      search: "",
      isLoading: false,
      plcHolder: "Pretražite rezultate",
      loadText: "Učitava se...",
      noResText: "Nema dostupnih osoba.",
      DropDownClosed: true,
      carrier_selected: false,
    };
  },
  methods: {
    setValue() {
      if(this.start != undefined)
      {
        //   this.results_selected = this.start;
        this.results_final = this.start

      }
    },
    removeSelectedResult(){
          this.results_final={"uid":'', "name":''};
      },
    onChange(tip) {
      this.$emit("input", this.search);

      if (this.isAsync) {
        this.isLoading = true;
      } else {
        this.filterResults();
        this.isOpen = true;
        if (this.results.length > 0) {
          gsap.to(".autocomplete-results-" + tip, 0, { display: "block", opacity:1});
        }
        else{
          gsap.to(".autocomplete-results-" + tip, 0, { display: "none", opacity:0});
        }
      }
    },
    filterResults() {
      // first uncapitalize all the things
      this.results = [];
      var tmpResults = this.items.filter((item) => {
        return item.value.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
      });
      var sideRes = [];

      if (tmpResults.length > 0) {
        //usklađivanje s početnim
        tmpResults.forEach((p) => {
          if (p.value.toLowerCase().startsWith(this.search.toLowerCase())) {
            this.results.push(p);
          } else {
            sideRes.push(p);
          }
        });
        this.results = this.results.concat(sideRes);
        this.firstResult = this.results[0];
      } else {
        this.firstResult = "";
      }
      if (this.search === "") {
        this.results = [];
        this.firstResult = "";
      }
    },
    handleClickOutside() {
      this.isOpen = false;
      this.arrowCounter = -1;

      this.unCheckbox();
      gsap.to(".autocomplete-results", 0.25, { opacity: 0 });
      gsap.to(".autocomplete-results", 0.25, { display: "none" });

      this.search = "";
    },
    selectCheckboxValue(i, tip) {
        this.unCheckbox();
      if (
        $(".autocomplete-checkbox-" + tip + ".cwrap" + i).hasClass(
          "checkbox-clicked"
        )
      ) {
        gsap.to(
          ".autocomplete-checkbox-" + tip + " #autocomplete-result" + i,
          0.2,
          { border: "4px solid #cccccc" }
        );
        gsap.to(
          ".autocomplete-checkbox-" + tip + " #autocomplete-result" + i,
          0.4,
          { backgroundColor: "transparent" }
        );
        $(".autocomplete-checkbox-" + tip + ".cwrap" + i).removeClass(
          "checkbox-clicked"
        );
      } else {
        gsap.to(
          ".autocomplete-checkbox-" + tip + " #autocomplete-result" + i,
          0.2,
          { border: "3px solid #c8f8f2" }
        );
        gsap.to(
          ".autocomplete-checkbox-" + tip + " #autocomplete-result" + i,
          0.4,
          { backgroundColor: "#0acab1" }
        );
        $(".autocomplete-checkbox-" + tip + ".cwrap" + i).addClass(
          "checkbox-clicked"
        );
      }

      if (
        $(".autocomplete-checkbox-" + tip + ".cwrap" + i).hasClass(
          "checkbox-clicked"
        )
      ) {
        //pospremi vrijednost na koju se kliknulo u clicked_result
        var clicked_result_uid = $('.autocomplete-checkbox-'+tip+'.cwrap'+i+' label').attr('value')
        var clicked_result_value = $(
          ".autocomplete-checkbox-" + tip + ".cwrap" + i + " label"
        ).text();
        var obj = {};
        //dodaj clicked vrijednosti
        obj["uid"] = clicked_result_uid;
        obj["name"] = clicked_result_value;
        this.results_selected = obj;
      } else {
        this.results_selected = {"uid":'', "name":''}
      }
    },

    //vizualno odselektiraj sve checkboxove i makni kliknute vrijednosti iz results_selected
    unCheckbox() {
      gsap.to(".custom-checkbox", 0.2, { border: "4px solid #cccccc" });
      gsap.to(".custom-checkbox", 0.4, { backgroundColor: "transparent" });
      $(".autocomplete-checkbox-wrapper").removeClass("checkbox-clicked");

      this.results_selected = {"uid":'', "name":''};
    },

    displaySelectedResults() {
      if (this.results_selected.uid == '') {
        alert("Odaberite jedan od rezultata, ili unesite novi");
      } else {
        //pusha selektirane rezultate u result_final
        this.results_final = this.results_selected;
        this.$emit('addedNadlezno');
        var tl = new gsap.timeline();
        tl.to(".autocomplete-results", 0.25, { opacity: 0 });
        tl.to(".autocomplete-results", 0, { display: "none" });
        tl.to(".results-selected-wrapper", 0, { display: "flex" });
        tl.to(".results-selected-wrapper", 0.25, { opacity: 1 });

        this.unCheckbox();

        this.search = "";

        setTimeout(() => {
          this.results = [];
        }, 500);
      }
    },
  },
  watch: {
    items: function (val, oldValue) {
      // actually compare them
      if (val.length !== oldValue.length) {
        this.results = val;
        this.isLoading = false;
      }
    },
  },
  computed: {
    isUnavailable() {
      return this.search !== "" && this.results.length === 0;
    },
  },
  mounted() {
    // document.addEventListener("click", this.handleClickOutside);
    var _this = this;
    $('.v-application--wrap').click(function (e) {
      var container = $(".outside-click-holder")
      var dialog = $(".v-dialog__content")
      if(!container.is(e.target) && container.has(e.target).length === 0 && !dialog.is(e.target) && dialog.has(e.target).length === 0) {
        _this.handleClickOutside();
      }
    });
    //definiranje jezika teksta
    if (this.$route.path.includes("/en")) {
      this.plcHolder = "search documents";
      this.loadText = "Loading results...";
      this.noResText = "There is no available documents.";
    }

    //*** ANIMACIJE */

    //autocomplete click animation (vučemo iz plugina)
    this.clickAnim(".autocomplete-confirm");

    //*** END ANIMACIJE */
        let vm = this;
      vm.$nextTick(function () {
        this.inputType = vm.id;
        setTimeout(this.setValue, 1000);
        var tl = new gsap.timeline();
        tl.to(".autocomplete-results", 0.25, { opacity: 0 });
        tl.to(".autocomplete-results", 0, { display: "none" });
        tl.to(".results-selected-wrapper", 0, { display: "flex" });
        tl.to(".results-selected-wrapper", 0.25, { opacity: 1 });
        if (this.inputType == "nadlezna-tijela") {
          this.show_statuses = false;
        }
    });
  },
  destroyed() {
    // document.removeEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    $('.v-application--wrap').off();
  },
};
</script>

<style>
</style>